<template>
    <div class="text-center" v-if="activeBanner">
        <a
            v-if="activeBanner.link"
            :href="activeBanner.link"
            :title="activeBanner.title"
            target="_blank"
        >
            <img
                :src="'/data/banners/' + activeBanner.file"
                :alt="activeBanner.alt"
                class="responsive-img">
        </a>
        <img
            v-else
            :src="'/data/banners/' + activeBanner.file"
            :alt="activeBanner.alt"
            class="responsive-img">
    </div>
</template>

<script>
export default {
    props: {
        area: {
            type: String,
            required: true
        }
    },

    data () {
        return {
            banners: [],
            activeBanner: null,
            activeIdx: -1
        }
    },

    mounted () {
        axios.get('/banners/' + this.area)
            .then(response => {
                this.banners = response.data

                if (this.banners.length) {
                    this.switchBanner()
                }
            })
            .catch((err) => {
                if (err.message == 'Network Error'){
                    console.log('Cannot get banners config. Maybe blocked by some AdBlock extension?')
                } else {
                    console.error(err)
                }
            })
    },

    methods: {
        switchBanner () {
            this.activeIdx++

            if (this.activeIdx >= this.banners.length) {
                this.activeIdx = 0
            }

            let img = new Image()
            img.src = '/data/banners/' + this.banners[this.activeIdx].file
            img.onload = () => {
                this.$emit('change')
            }

            this.activeBanner = this.banners[this.activeIdx]

            setTimeout(this.switchBanner, 15000)
        }
    }
}
</script>
